module.exports = __webpack_public_path__ + "static/media/cscc-4.dc150833.jpg";